import { Colors } from '@brg/ui';

import hexToRGB from 'shared/helpers/hexToRGB';

export const blackTheme = {
    themeName: 'blackTheme',
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: '',
    },
    app: {
        backgroundColor: '#000000',
        text: '#FEFEFE',
        ten: Colors.galBlack73,
    },
    projectStudent: {
        color: '#fff'
    },
    panel: {
        title: Colors.galBlack100,
        button: {
            bg: Colors.geoWhite100,
        }
    },
    cardsEmptyModal: {
        titleColor: '#000',
        subtitleColor: Colors.galBlack100,
        bg: '#FEFEFE',
        buttons: {
          filled: {
            color: '#FFF',
            bg: Colors.galBlack100
          },
          hollow: {
            color: Colors.galBlack100,
            border: Colors.galBlack47
          }
        }
    },
    commonCheckbox: {
        border: '#8e9193',
        color: '#fff',
        bg: '#2C2C2B',
        icon: {
            active: '#fff',
            notActive: 'transparent'
        }
    },
    tabs: {
        gradient: Colors.geo,
    },
    table: {
        border: Colors.galBlack100,
        headerBg: Colors.white,
        text: Colors.white,
        icon: {
            default: Colors.geoWhite47,
            active: Colors.geoWhite73,
        },
    },
    viewType: {
        item: {
            active: Colors.white,
            default: Colors.galBlack47,
            hover: Colors.galBlack27
        }
    },
    peoplePage: {
        title: {
            color: '#fff'
        }
    },
    subscribeInfo: {
        color: '#fefefe',
        hover: '#c5c6c7'
    },
    subscribeModal: {
        title: 'rgba(255, 255, 255, 1)',
        subTitle: 'rgba(255, 255, 255, 1)',
        channeTitle: "rgba(255, 255, 255, 1)"
    },
    teamMeta: {
        color: Colors.galBlack47,
        hover: Colors.galBlack73
    },
    landing_nav: {
        bg: '#464645',
        item: {
            color: '#A3A3A3',
            bg: '#464645',
            hover: '#464645',
            hoverColor: '#BFBFBF'
        }
    },
    folders: {
        emptyModal: {
            titleColor: '#fff',
            subtitleColor: '#fff'
        },
        editModal: {
            mainbg: '#2A3034',
            titleColor: '#2A3034',
            subtitleColor: '#909090',
            inputColor: '#353a3e',
            inputColor2: '#fff',
            buttonColorHollow: '#fff',
            buttonColorFill: '#fff',
            iconColor: '#fff'
        }
    },
    mainSearchBar: {
        bg: '#2C2C2B',
        placeholder: {
            color: Colors.galBlack47
        },
        input: {
            bg: '#2C2C2B',
            placeholder: {
                color: '#5D5D5D'
            }
        },
        text: {
            color: '#FEFEFE',
            color_desc: '#FEFEFE',
            hover: {
                color: '#353A3E'
            }
        },
        tabs: {
            color: "#909090",
            colorActive: "#fefefe"
        }
    },
    longreadTranslated: {
        bg: 'rgba(144, 144, 144, 0.8)',
        color: 'rgba(254, 254, 254, 1)'
    },
    relatedTitle:'rgba(254, 254, 254, 1)', 
    mainSearchBarFooter: {
        bg: '#2A3034',
        placeholder: {
            color: Colors.galBlack47
        },
    },
    educationSearchBar: {
        result: {
            color: '#fff'
        }
    },
    approvalBlockStyles: {
        color: Colors.galBlack47,
        bg: '#2C2C2B',
        radioCircle: '#2C2C2B',
        radioDot: '#FEFEFE',
        buttonColor: '#151514',
        buttonBg: '#FEFEFE'
    },
    mainDropdownStyles: {
        colorActive: Colors.geoWhite100,
        color: '#838382',
        bg: 'rgb(31, 31, 31)',
        hoverBG: ' rgb(44, 44, 43)'
    },
    mainBg: '#151514',
    loading: Colors.geoWhite47,
    tagView: {
        titleColor: Colors.geoWhite100,

        // Медиа
        goToMediaColor: Colors.geoWhite100,
        goToMediaHoverColor: Colors.geoWhite31,
    },
    longread: {
        border: 'none',
        fontSize: '',
        lineHeight: '',
    },
    progressbar: {
        color: Colors.geoWhite47,
        colorBold: Colors.geoWhite100,
        borderColor: Colors.geoWhite31
    },
    competition: {
        modal: {
            tagsTitle: {
                color: '#909090'
            }
        },
        search: {
            smallColor: Colors.geoWhite61
        },
        jury: {
            name: '#151514'
        },
        shortList: {
            description: {
                text: '#151514'
            }
        },
        result_table: {
            bg: "#cdcdcd",
            color: '#C5C6C7',
            border: '#575B5E'
        },
        nominationsBlock: {
            label: {
                color: '#fff'
            }
        },
        bg: '#000000',
        mainText: '#FEFEFE',
        frameMainText: '#fefefe',
        secondaryText: Colors.galBlack47,
        buttonBg: Colors.geoWhite100,
        buttonText: Colors.galBlack100,
        juryDesc: Colors.geoWhite47,
        langComponent: {
            active: {
                bg: '#BFBFBF',
                color: '#212120'
            },
            notActive: {
                bg: '#464645',
                color: '#909090'
            },

            mainSwitcher: {
                active: {
                    bg: '#BFBFBF',
                    color: '#212120'
                },
                notActive: {
                    bg: 'transparent',
                    color: '#BFBFBF'
                },
            }
        },
        label: {
            color: '#909090'
        },
        input: {
            bg: '#2C2C2B',
            bgActive: Colors.galBlack10,
            inputText: '#fff',
            placeholder: '#5D5D5D',
            mainText: '#151514',
            secondText: '#fefefe',
            button: {
                border: '#545453',
                bg:  '#F2F2F2'
            },
            checkbox: {
                border: '#838382',
                icon: '#fff',
                bg:  '#464645',
            },
            date: {
                bgNow: 'white',
                bgActive: 'transparent',
                colorNow: 'black',
                colorActive: 'white'
            }
        },
        table: {
            item: {
                bg: '#343434'
            },
            input: {
                bg: '#464645',
                color: '#fefefe',
                border: '#343434'
            }
        }
    },
    tagSearch: {
        titleColor: Colors.geoWhite47,
        subtitleColor: Colors.geoWhite47,
        subtitleColorHover: Colors.geoWhite100,
        inputColor: Colors.geoWhite100,
        background: Colors.geoWhite5,
        arrowColor: Colors.geoWhite47,
    },
    catalog: {
        titleColor: Colors.geoWhite100,
        subtitleColor: Colors.geoWhite100,
        descriptionColor: Colors.geoWhite100
    },
    tagItemView: {
        textColor: Colors.geoWhite100,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100,
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: Colors.geoWhite100,
    },
    exploreView: {
        titleColor: Colors.geoWhite100,
        mapGridToggle: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100,
        },
        illustrationColor: Colors.geoWhite73
    },
    allTagsBtn: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        colorBooksBtn: "#909090",
        colorHoverBooksBtn: "#545453"
    },
    multipleAuthors: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        bg: '#1c1c1d',
        bgHover: '',
        arrow: '#1c1c1d',
        border: '',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.geoWhite61,
    designerRoleUniversity: Colors.geoWhite100,
    textBoldMagic: Colors.geoWhite47,
    teamLink: Colors.geoWhite100,
    teamLinkHover: Colors.geoWhite61,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '',
        borderColor: 'transparent',
    },
    projectTools: {
        printButton: Colors.geoWhite100,
        outer: Colors.geoWhite10,
        rowTitle: Colors.gal,
        rowHover: Colors.geoWhite5,
        okBtn: "#A4B54D",
        okBtnText: Colors.geo,
    },
    checkbox: {
        border: "transparent",
        bg: Colors.geoWhite21,
        icon: Colors.geoWhite100,
    },
    paginationBtn: {
        color: '',
        border: '',
    },
    sortByColor: Colors.geoWhite47,
    sortByColorSort: Colors.geoWhite100,
    sortByBorder: '',
    sortByBg: '',
    sortBySpan: '#fefefe',
    nameViewHover: '#fefefe',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#262a2d',
        text: '#FFFFFF',
        scroll: '#909090',
        btns: {
            submit: {
                bg: Colors.geoWhite100,
                disabledBg: '#3F4548',
                color: '#151514',
                disabledColor: '#6C7073',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: '',
            },
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent',
            },
            dropdown: {
                backgroundColor: Colors.geoWhite5,
                backgroundColorHover: Colors.geoWhite10,
                scroll: Colors.galBlack47,
            },
            backgroundColor: Colors.geoWhite5,
            borderColor: Colors.geoWhite5,
            color: '#ffffff',
        },
    },
    feedbackForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: '',
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent',
            },
            dropdown: {
                backgroundColorHover: '',
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe',
        },
    },
    defaultHolder: {
        bg: '#353A3E',
        color: '#909090'
    },
    projectView: {
        titleColor: Colors.geoWhite100,
        titleColorMobile: Colors.geoWhite100,
        lGTitleColorMobile: Colors.geoWhite100,
        placeholderColor: '#B6B6B5',
        fontSize: '',
        lineHeight: '',
        tooltipColor: '#FFFFFF',
        tooltipColorBG: '#545453',
        categoryText: Colors.geoWhite31,
        categoryWeight: '',
        categoryColorHover: '',
        authorText: 'rgba(255,255,255,0.47)',
        authorCuratorText: Colors.geoWhite100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorTextSize: Colors.geoWhite73,
        authorColor: Colors.geoWhite47,
        authorColorHover: Colors.geoWhite100,
        authorColorHoverMobile: Colors.geoWhite61,
        authorArrowIconColor: Colors.geoWhite47,
        textAreaColor: Colors.geoWhite31,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#909090',
        marginTop: '',
        marginBottom: '',
        designerLink: Colors.geoWhite100,
        moreProjects: '#FFFFFF',
        offsetTop: '',
        madeBy: Colors.geoWhite47,
        border: 'transparent',
        competitionMsg: Colors.geoWhite100
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)',
    },
    footerView: {
        backgroundColor: '#22282c',
        textColor: Colors.geoWhite61,
        textHoverColor: Colors.generalPeaGreen,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
        linkArrow: Colors.geoWhite27,
    },
    arrowWithText: {
        hover: {
            text: {
                color: 'rgb(254,254,254)'
            },
            svg: {
                fill: 'rgb(254,254,254)',
                stroke: 'rgb(254,254,254)'
            }
        }
    },
    teamsPage: {
        button: {
            bg: '#FFFFFF'
        },
        dropdown: {
            text: {
                color: '#f4f4f4'
            }
        },
        input: {
            bg: "#30363A",
            color: '#f4f4f4'
        },
        text: {
            point: {
                color: '#f4f4f4'
            },
            label: {
                color: '#8E9193'
            },
            icon: {
                fill: '#fefefe'
            },
            color: '#ffffff'
        },
    },
    fixedFooter: {
        background: {
            color: "#1F1F1F"
        },
        logo: {
            color: "#FEFEFE",
        },
        menuItems: {
            color: '#8E9193',
            colorDropdown: '#8E9193',
            colorHover: "rgb(254, 254, 254)",
            selected: Colors.geoWhite100,
        },
        doc: {
            color: '#909090',
            colorHover: "#151514",
        },
        icons: {
            circle: '#1F1F1F',
            arrow: '#909090'
        },
        dropdown: {
            color: '#909090',
            fill: '#909090'
        }
    },
    legals: {
        textColor: Colors.geoWhite100,
        background: `${Colors.geo}FA`,
        closeBtn: Colors.geoWhite47,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
    },
    scroll: {
        bg: '#909090'
    },
    mobileLinks: {
        borderColor: "rgba(63, 69, 72, 1)"
    },
    cookies: {
        bg: "#212120",
        mainColor: "#fefefe",
        showMore: {
            color: '#fff'
        },
        icon: {
            fill: "#909090",
            hoverFill: "#fff"
        }
    },
    projectEdit: {
        book: {
            chaptersButtons: {
                hover: {
                    fill: '#fff'
                },
                color: '#fff'
            }
        },
        radio: {
            dot: {
                color: Colors.geoWhite100
            }
        },
        inputs: {
            bg: Colors.galBlack5,
            color: Colors.galBlack100,
            placeholder: Colors.galBlack31
        }, 
        protectBlock: {
            input: {
                bg: '#3F4548',
                altBg: Colors.galBlack5,
                color: Colors.galBlack100,
                placeholder: {
                    color: Colors.galBlack31
                }
            },
            infoMsg: {
                color: '#909090'
            },

            paid_block: {
                button: {
                    bg: '#151514',
                    color: '#fff'
                }
            }
        },
        presentation: {
            input: {
                bg: '#2C2C2B',
                dropdownHover: '#464645'
            }
        },
        imgContainerBg: '#2C2C2B',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.zelWhite47,
        locationText: Colors.geoWhite61,
        locationBoldText: Colors.geoWhite47,
        label: '#ffffff',
        frame: {
            mainTitle: {
                color: '#C5C6C7'
            },
            description: {
                color: '#C5C6C7'
            },
            link: {
                color: '#6C7073'
            }
        },
        btns: {
            age: {
                bg: '#2C2C2B',
                border: Colors.galBlack47,
                icon: {
                    color: '#fff'
                }
            },
            lang: {
                active: '#f4f4f4',
                disabled: '#3F4548',
                activeColor: '#151514',
                disabledColor: '#909090',
                biling: {
                    color: '#909090',
                    bg: '#3F4548',
                    border: 'transparent'
                }
            },
            create: {
                bg: '',
                color: '',
                weight: '',
                border: '',
            },
            tag: {
                bgActive: '#fff',
                border: '#8E9193',
                borderActive: '#fff',
                color: '#FFFFFF',
                colorActive: '#151514'
            },
            navbar: {
                disabled: {
                    bg: '#212120',
                    color: '#8E9193'
                },
                exit: {
                    border: {
                        notActive: {
                            color: '#575B5E'
                        }
                    }
                }
            }
        },
        mobile: {
            inputs: {
                color: '#fff',
                bg: '#353A3E',
                placeholder: '#909090'
            },
            items: {
                color: '#fefefe',
                bg: 'transparent'
            },
            buttons: {
                color: '#FFFFFF',
                bg: 'transparent',
                border: '#FFFFFF',
                fill: '#FFFFFF',
                hover: {
                    color: '#CDCDCD',
                    border: '#CDCDCD',
                },
                disabled: {
                    bg: 'transparent',
                    color: '#545453',
                    border: '#545453',
                }
            }
        },
        header: {
            color: 'rgba(255, 255, 255, 0.47);'
        },
        search: {
            inputs: {
                fill: "#909090",
                hoverFill: "#fefefe"
            }
        },
        publishModal: {
            bg: "#3F4548",
            title: {
                color: "#fefefe"
            },
            subtitle: {
                color: "#fefefe"
            },
            buttons: {
                hollow: {
                    color: "#151514",
                    bg: "#fefefe",
                    border: '#b6b6b5'
                },
                filled: {
                    color: "#fefefe",
                    bg: "#151514",
                    border: "transparent"
                }
            }
        }
    },
    icon: {
        default: 'rgba(255,255,255,0.47)',
        hover: Colors.geoWhite100,
        active: Colors.geoWhite100,
        hoverSpecial: Colors.geoWhite100,
        hoverSpecialActive: "#909090",
        activeSpecial: Colors.geoWhite100,
        activeFillIconColor: Colors.geoWhite100,
        rejectedColor: '#F2F2F2',
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.geoWhite100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        projectEditTagsPlusBtn: '#fefefe',
        tagsSearchPlaceholderText: Colors.geoWhite61,
        emptySearchColor: Colors.geoWhite61,
        competitionSortColor: '#151514',

        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.galBlack27,
        borderColorActive: Colors.geoWhite100,

        selectedCategory: Colors.zelWhite5,

        cloud: {
            background: Colors.galBlack5,
            selectedTag: '#EA3323',
            selectedTagHSE: '#146DEE',
            selectedTagHSEHover: '#0A56C4',
        },

        tagEditModal: {
            buttons: {
                edit: {
                    color: '#fff',
                    borderColor: '#fff'
                }
            },
            subTitle: {
                color: '#fff'
            },
            input: {
                bg: '#3f4548',
                color: '#fff'
            },
            text: {
                color: '#fff'
            }
        },

        removable: {
            textColorHover: Colors.galBlack47,
            borderColorHover: Colors.galBlack47,

            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100,
                },
                textColor: Colors.galBlack47,
                borderColor: '#FFFFFF',
            },
        },

        selected: {
            backgroundColor: '#FFFFFF',
            borderColor: '#2a3034',
            textColor: '#000000',
            hover: {
                borderColor: '#FFFFFF',
            },
        },
        disabled: {
            backgroundColor: '#272b2d',
            borderColor: '#3f4548',
            color: Colors.geoWhite21,

            hover: {
                borderColor: '#3f4548',
            },
        },
        educational: {
            backgroundColor: Colors.geoWhite100,
            backgroundColorHover: Colors.geoWhite5,
            color: Colors.galBlack100,
            unitColor: Colors.geoWhite100,
            projectEdit: {
                // backgroundColor: Colors.generalPeaGreen,
                backgroundColor: Colors.geoWhite100,
                backgroundHover: Colors.geoWhite100,
                color: '#2A3034',
            }
        },
        modal: {
            search: {
                color: Colors.geoWhite47,
                border: Colors.geoWhite21,
                borderEmpty: 'transparent',
                bg: '#212120'
            },
            header: {
                color: Colors.geoWhite100,
                colorLvlOne: Colors.geoWhite100
            },
            text: {
                color: Colors.geoWhite47,
            },
            active: {
                activeTag: Colors.geoWhite100,
                border: Colors.geoWhite61
            },
            searchResult: {
                bg: '#212120'
            },
            notActive: {
                tag: Colors.geoWhite73,
                border: Colors.geoWhite31
            },
            simpleTag: {
                color: Colors.geoWhite100,
                bottomLine: '#3F4548'
            }
        }
    },
    hoverModal: {
        bg: {
            color: '#212120'
        }
    },
    skeleton: {
        skeletonBgColor: 'rgba(63, 69, 72, 0.5)',
        background: `linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.10),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05)
        )`,
    },
    selectContextModal: {
        background: Colors.geo,
        loaderText: '#FEFEFE',
        opacityTop: 'linear-gradient(to top, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        opacityBottom:
          'linear-gradient(to bottom, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        variantTextColor: Colors.geoWhite100,
    },
    shopIcon: Colors.geoWhite100,
    shareIcon: Colors.geoWhite100,
    shareModal: {
        bg: '#212120',
        inputs: {
            bg: '#3F4548'
        }
    },
    ageModal: {
        bg: '#353A3E',
        input:{
            color: '#fff'
        },
    },
    sendProjectsModal: {
        title: Colors.geoWhite100,
        label: Colors.galBlack47,
        countText: '#909090',
        buttons: {
            send: {
                bg: Colors.geoWhite100,
                color: Colors.galBlack100,
                importantColor: Colors.geoWhite100,
                colorGreen: Colors.galBlack100,
                hoverBg: Colors.geoWhite100,
                greenBg: 'rgb(164, 181, 77)',
                greenBgHover: 'rgb(164, 181, 77)',
                disable: "#C5C6C7",
                disableClr: '#8E9193'
            }
        },
        input: {
            color: '#fff',
            bg: 'rgb(70, 70, 69)'
        }
    },
    competitionLegalsModal: {
        input: {
            bg: '#30363A',
            placeholder: '#909090',
            color: Colors.geoWhite100,
            border: '#909090',
            icon: Colors.geoWhite100,
            defaultBorder: 'transparent'
        }
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    navigationBar: {
        borderBottomColor: Colors.geoWhite21,
        textActiveColor: '#ffffff',
        boxShadow: 'inset 0px 2px 3px rgba(22, 22, 23, 0.21)',
        closeButtonColor: '#FFFFFF',
        backgroundColor: '#151514',
        mainNavbarColor: 'rgb(42,48,52)',
        backgroundScrollingColor: '#000000',
        backgroundDirtyColor: '#FF0000',
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: '#8E9193',
            hoverColor: '#C5C6C7',
            activeColor: '#C5C6C7',
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(197, 198, 199, 0.3)'
        },
        linksHse: {
            color: Colors.geoWhite47,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(197, 198, 199, 0.3)'
        },
        logoName: '#FF0000',
        logoPrefixName: Colors.geoWhite100,
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: Colors.geoWhite100,
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477',

            dropDownColor: Colors.galBlack47,
            dropDownBackground: '#1f1f1f',
            dropDownDisabledColor: '#B6B6B5',
            dropDownHoverBackground: '#212120',
            dropDownHoverColor: Colors.galBlack73,
            dropdownContentBg: '#1f1f1f',
            dropDownShadowColor: '#1f1f1f',
        },
        search: {
            color: '#FEFEFE',
            line: '#FFFFFF',
            svg: '#8E9193',
            svgHover: Colors.geoWhite100,
            colorFlex: 'rgb(254, 254, 254, 0.71)',
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: '#fff',
        },
        linksWidgetLine: '#ffffff',
        linksWidgetLineGradient: Colors.geoWhite100, //old ' radial-gradient(100% 1562500% at 0% 100.02%,rgba(255, 255, 255, 0) 0%,#fefefe 49.87%,rgba(254, 254, 254, 0) 100%)',
        btns: {
            purchase: {
                background: {
                    color: Colors.geoWhite100
                },
                text: {
                    color: Colors.galBlack100
                }
            },
            filled: {
                importantStyles: {
                    main: Colors.generalPeaGreen,
                    disabled: Colors.galBlack10,
                    hover: '#FFFFFFF',
                    active: '#FFFFFFF',
                    text: Colors.galBlack100
                },
                background: {
                    main: '#FEFEFE',
                    disabled: Colors.galBlack10,
                    hover: '#FFFFFFF',
                    active: '#FFFFFFF',
                },
                text: {
                    main: '#151514',
                    disabled: Colors.galBlack31,
                },
            },
            hollow: {
                background: {
                    disabled: Colors.geoWhite73,
                },
                text: {
                    main: '#ffffff',
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.geoWhite47,
                },
                border: {
                    main: Colors.geoWhite21,
                    hover: Colors.geoWhite31,
                    active: Colors.geoWhite47,
                    disabled: Colors.geoWhite10,
                },
            },
            send: {
                color: '',
                textColor: '',
                border: '',
            },
            create: {
                bg: '#FFFFFF',
                color: Colors.galBlack100,
                weight: '',
                border: '',
            },
            changeLang: {
                background: '#212120',
                color: Colors.geoWhite47,
                colorMobile: Colors.geoWhite100,
                colorHover: Colors.geoWhite47,
                active: Colors.geoWhite100,
            },
            showMore: {
                hover: {
                    color: Colors.zelWhite73
                }
            }
        },
        navBarCreate: {
            boldTextColor: Colors.geoWhite61,
            textColor: '#6C7073',
            logoFillColor: {
                first: '#FEFEFE',
                second: '#A4B54D',
            },
        },
        dropdownStyled: {
            bg: '#30363a',
            border: '1px solid rgba(254, 254, 254, 0)',
            borderFocused: 'rgba(254, 254, 254, 0.13)',
            textColor: '#fefefe',
            opacity: '0.31',
            fill: '#fefefe',
        },
        profile: {
            textColor: Colors.geoWhite100,
            textSmallColor: Colors.geoWhite61,
            bg: Colors.geo,
        },
        mobileMenu: {
            item: {
                color: '#909090',
                colorActive: '#FFFFFF',
                bg: 'rgba(33, 33, 32, 1)'
            },
            container: {
                bg: 'rgba(33, 33, 32, 1)',
                boxShadow: 'inset 0 -1px 0 #3f4548'
            },
            search: {
                bg: '#575B5E'
            },
            tab: {
                color: 'rgba(131, 131, 130, 1)',
                colorActive: '#ffffff'
            }
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.geoWhite10,
            backgroundHover: Colors.geoWhite5,
        },
        scroll: {
            body: Colors.galBlack47,
            background: Colors.geoWhite5,
        },
        input: {
            color: Colors.geoWhite100
        },
        item: {
            color: Colors.geoWhite100,
        }
    },
    likesController: {
        textColor: Colors.geoWhite47,
        fill: '',
        hearthColor: Colors.geoWhite47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.geoWhite47,
    },
    viewCount: {
        text: Colors.geoWhite47
    },
    likesPopUp: {
        bg: '#1c1c1b',
        color: '#abaeaf',
        hoverColor: Colors.geoWhite100,
        bgHover: '',
        borderBox: '1px solid transparent',
    },
    likesPopUpNew: {
        bg: Colors.geoWhite10,
        color: Colors.geoWhite100,
        bgHover: Colors.geoWhite5,
        scrollBody: Colors.galBlack47,
    },
    researchPage: {
        colorMainTitle: Colors.geoWhite61,
    },
    btns: {
        submit: {
            bg: '#fede31',
            color: Colors.galBlack100,
            border: '',
            hoverBg: '#efd649',
            weight: '',
        },
        cancel: {
            bg: '',
            color: '',
            border: '',
            hoverBorder: '',
        },
        hollow: {
            border: Colors.geoWhite21,
            borderActive: Colors.geoWhite100,
            icon: Colors.geoWhite100,
        }
    },
    inputs: {
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: 'transparent',
        },
        dropdown: {
            backgroundColorHover: '',
        },
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderFocusedColor: Colors.geoWhite31,
        color: 'rgba(144, 144, 144, 1)',
        disabledColor: Colors.geoWhite100,
        pagination: {
            backgroundColor: Colors.zelWhite21,
            color: Colors.geoWhite100,
            mainPagination: {
                pageBg: {
                    bg: '#464645'
                }
            }
        },
        box: {
            backgroundColor: 'rgba(44, 44, 43, 1)'
        },
        label: {
            color: 'rgba(144, 144, 144, 1)'
        },
        text: {
            color: Colors.geoWhite47
        }
    },
    dropdown: {
        scrollColor: '#5D5D5D',
        textColor: Colors.galBlack100,
        bgColor: '#32373b',
        bgColorHover: '#212120',
        borderColor: '#30363a',
        borderFocusColor: 'transparent',
        arrow: '#fefefe',
        shadow: 'rgba(0, 0, 0, 0.3)',
        shadowEnd: 'rgba(0, 0, 0, 1)',

        shadowHse: 'rgba(0,0,0,0)',
        shadowHseEnd: '#343434',
        webkitShadowStart: 'rgba(52,52,52,1)',
        webkitShadowEnd: 'rgba(52,52,52,0.3)'
    },
    spinner: {
        loaderColor: '#ffffff',
        loaderBg: Colors.geo,
    },
    designerPage: {
        emptyProjectsLoader: {
            color: Colors.geoWhite100,
            bg: '#30363a',
        },
        noProjectBlock: {
            infoBlock: {
                bg: '#212120',
                color: '#fefefe'
            },
            avatar: {
                color: '#70706f',
                bg: '#909090',
                size: {
                    l: 48
                }
            }
        },
        likePowerIcon: {
            color: Colors.geoWhite47,
            bg: 'rgba(254,254,254,0.73)',
            opacity: '0.73',
            msgColor: Colors.galBlack100,
            shrinkColor: Colors.galBlack100,
            hover: Colors.geoWhite73
        },
        slideShadow: 'linear-gradient(270deg, #000000 9.68%, rgba(42, 48, 52, 0.00) 100%)',
        slideItemBg: Colors.geoWhite10,
        textColor: Colors.geoWhite100,
        textColor2: Colors.geoWhite47,
        textColor3: Colors.geoWhite100,
        fill: '#FEFEFE',
        sliderDropdownColor: '#909090',
        moreDropdown: '',
        slideLine: '#f4f4f4',
        slideNavActiveTabUnderline: '#FFFFFF',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.geoWhite73,
        blueSelectBG: '#609AF0', 
        blueSelectColor: '#fefefe' , 
        viewCardText: '#FEFEFE',
        viewCardStroke: '#8e9193',
    },
    wideCover: {
        info: {
            author: {
                color: Colors.galBlack47,
            },
            title: {
                color: '#151514'
            }
        }
    },
    teamsEdit: {
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        }
    },
    gridItem: {
        color: '#fff'
    },
    designerEdit: {
        btns: {
            edit: {
                bg: '#fff',
                color: Colors.galBlack100,
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#f4f4f4',
                border: '',
                hoverBorder: '',
            },
            roundAdd: {
                svgColor: Colors.geoWhite100,
                textColor: Colors.geoWhite47,
            },
            subscribe: {
                dropdown: {
                    color: '#8E9193',
                    background: '#1f1f1f',
                    hoverBg: '#2c2c2b',
                    hoverColor: '#bfbfbf'
                }
            }
        },
        localSwitch: {
            borderColor: Colors.geoWhite100,
            textColor: Colors.geoWhite100,
            textColorInactive: Colors.geoWhite47,
            textColorHover: Colors.geoWhite73,
        },
        inputs: {
            labelColor: 'rgba(142, 145, 147, 1)',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)',
            placeholder: '#5D5D5D'
        },
        smallText: {
            color73: Colors.geoWhite73,
            color100: "rgba(144, 144, 144, 1)",
            color47: Colors.geoWhite47,
            colorB6: '#B6B6B5',
            colorE7: 'rgba(144, 144, 144, 1)'
        },
        editTitle: {
            color: 'rgba(144, 144, 144, 1)',
            secondColor: Colors.geoWhite100
        },
        mainTitle: {
            color: '#f4f4f4',
        },
        pageLink: {
            color: Colors.geoWhite100,
            hoverColor: Colors.geoWhite100,
        },
        aboutProfile: {
            bg: 'rgba(44, 44, 43, 1)',
            bgWhite: Colors.geoWhite73,
            color: Colors.geoWhite100,
        },
        mergeAccount: {
            bg: 'rgba(33, 33, 32, 1)'
        },
        account: {
            color: 'rgba(144, 144, 144, 1)',
            color47: Colors.geoWhite47,
            goButtonColor: 'rgb(244,244,244)',
            color31: 'rgba(144, 144, 144, 1)',
            fill: 'rgb(205, 205, 205)'
        },
        icons: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        disable: {
            color: Colors.geoWhite27,
            colorGeo: Colors.galBlack47
        },
        placeholder: {
            color: 'rgb(108, 112, 115)',
        }
    },
    map: {
        closeBtn: '#ffffff',
        bg: '#2a3034',
        exploreBtn: {
            mobile: {
                color: '#838382',
                fill: '#838382'
            },
            desktop: {
                color: '#8E9193',
                fill: '#8E9193'
            }


        },
        teams: {
            text: Colors.galBlack61,
            secondaryText: Colors.galBlack47,
            scroll: '#CDCDCD'
        }
    },
    footer: {
        border: '',
    },
    errorModal: {
        textColor: Colors.geoWhite100,
        textColorSecond: Colors.geoWhite100,
        secondaryTextColor: Colors.geoWhite47,
        backgroundColor: Colors.geo,
    },
    modal: {
        closeColor: Colors.geoWhite100,
        backgroundColor: 'rgba(38, 44, 48)',
        solidBackgroundColor: "#000",
        overflowColor: 'rgba(21, 21, 20, 0.6)',
        buttons: {
            saveButtonBG: '#fefefe',
            saveButtonColor: '#151514'
        },
        tagModal: {
            buttons: {
                saveButtonBG: '#fefefe',
                saveButtonColor: '#151514'
            }
        }
    },
    not_saved_modal: {
        title: "#f4f4f4",
        description: "rgb(197, 198, 199)",
        cancel: Colors.galBlack100,
        proceed: Colors.geoWhite100,
        channelTitle: Colors.galBlack47
    },
    gallllery: {
        cardSubtext: '#919191',
        mainText: Colors.galBlack100,
        mainTextInactive: '#969696',
        hoverTitleText: '#FFD700',
        hoverText: '#919191',
        hoverAuthor: Colors.galBlack100,
        backgroundColor: 'white',
        borderBottomColor: 'transparent',
        boxShadow: 'none',
        backdrop: 'blur(1px)',
    },
    artz: {
        searchLine: {
            placeholderColor: '#1F1F1F',
            textColor: Colors.galBlack100,
        },
        buttons: {
            viewAllColor: Colors.gal,
        },
    },
    menuOverlay: {
        buttonBackground: '#353a3e',
        buttonContent: '#C5C6C7',
        buttonOpacity: 0.39,
        backgroundColor: '#2a3034',
        textColor: '#ffffff',
        textColorAlternative: '#ABAEAF',
        borderTitle: '#fefefe',
        flexBox: 'rgb(254, 254, 254, 0.71)',
    },
    approvals: {

    },
    isDarkText: false,
    link: {
        default: Colors.geoWhite47,
        hover: Colors.geoWhite100,
    },
    linkSpecial: {
        hover: Colors.geoWhite100,
    },
    scrollUp: {
        link: Colors.zelWhite100,
        background: 'transparent',
        backgroundHover: hexToRGB(Colors.zelWhite100, 0.01),
    },
    text: {
        label: Colors.geoWhite47,
    },
    mobileMenu: {
        background: '#2A3034',
    },
    notifications: {
        background: '#2C2C2B',
        backgroundUnread: Colors.geoWhite5,
        backgroundHover: "#212120",
        borderColor: "#464645",
        projectBackground: Colors.geoWhite21,
        projectBackgroundUnread: Colors.geoWhite10,
        likes: Colors.galBlack27,
        textColor: '#FFFFFF',
        link: '#FFFFFF',

        name: {
            color: "#151514",
        }
    },
    errorPage: {
        notFound: {
            number: Colors.geoWhite31,
            title: Colors.geoWhite47
        },
        title: Colors.geoWhite100,
        subtitle: Colors.geoWhite100,
        text: Colors.geoWhite47,
        buttons: {
            border: Colors.geoWhite31,
            hollowText: Colors.geoWhite100,
            bg: Colors.geoWhite100,
            filledText: Colors.geo,
            disabledBg: Colors.galBlack21,
            disabledColor: Colors.galBlack31,
        }
    },
    imagePlaceholder: {
        bg: "#30363a",
        icon: "#65696c"
    },
    draftCreate: {
        primary: "#30363a",
        secondary: "#c5c6c7",
        borderHover: "#8e9193",
        textHover: "#fefefe",
        title: Colors.geoWhite100,
        draftCards: {
            psn_card: {
                color: Colors.galBlack100
            }
        }
    },
    tagAdminPage: {
        dropdownSelected: "#FEFEFE",
        dropdown: "#FEFEFE",
        inputs: {
            bg: 'rgba(63, 69, 72, 1)',
            border: 'transparent',
            placeholder: {
                color: 'rgba(144, 144, 144, 1)'
            }
        },
        checkbox: {
            bg: '#fefefe'
        },
        select: {
            color: '#fff'
        },
        scrollBar: {
            bg: '#fff',
            trackBg: 'rgba(53, 58, 62, 1)'
        },
        icons: {
            fill: '#909090'
        },
        tagExpert: {
            mainText: Colors.geoWhite27,
            secondaryText: Colors.galBlack47,
            secondaryTextHover: Colors.geoWhite100,
            background: Colors.geoWhite10
        },
        switcher: {
            bg: 'rgba(63,69,72,1)',
            item: {
                color: '#838382',
                hoverColor: Colors.geoWhite100
            }
        }
    },
    sendGift: {
        white: "",
        background: "#F2F2F2",
        mainBg: "",
        bg10: "",
        bg21: "",
        black: "",
        buttonBlack: "",
        share: "",
        text: "",
        text47: "",
        text61: "",
        text73: "",
        input: {
            hover: "",
            focus: "",
        },
        addDet: {
        }
    },
    payment: {
        bigText: Colors.zelWhite100,
        summary: Colors.zelWhite10,
        country: {
            viewLabel: Colors.galBlack61,
            draftMessage: Colors.galBlack73,
            successMessage: Colors.galBlack47,
        },
        chooseMethod: {
            bg: 'inherit',
            methods: {
                tugriks: {
                    bg: Colors.zelWhite10,
                    bgInactive: "#B4BBBD",
                    giftBg: Colors.zelWhite5,
                    hoverBg: "#2E2E2D",
                    hoverGiftBg: "#252524",
                    title: Colors.zelWhite100,
                    desc: Colors.zelWhite73,
                    paymentVal: Colors.zelWhite73,
                    additional: Colors.zelWhite73
                }
            }
        }
    },
    topup: {
        wrapper: Colors.gal,
        wrapperMob: Colors.galBlack10,
        title: Colors.galBlack100,
        bundle: {
            wrapper: Colors.galBlack5,
            title: Colors.galBlack73,
            subtitle: Colors.galBlack47,
            hint: Colors.galBlack31,
            amount: Colors.galBlack100
        },
        button: Colors.galBlack100,
        buttonText: Colors.gal
    },
    madeByMedia: {
        background: '#464645',
        color: '#FEFEFE'
    }
};import { Colors } from '@brg/ui';

import hexToRGB from 'shared/helpers/hexToRGB';

export const blackTheme = {
    themeName: 'blackTheme',
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: '',
    },
    app: {
        backgroundColor: '#000000',
        text: '#FEFEFE',
        ten: Colors.galBlack73,
    },
    projectStudent: {
        color: '#fff'
    },
    panel: {
        title: Colors.galBlack100,
        button: {
            bg: Colors.geoWhite100,
        }
    },
    cardsEmptyModal: {
        titleColor: '#000',
        subtitleColor: Colors.galBlack100,
        bg: '#FEFEFE',
        buttons: {
          filled: {
            color: '#FFF',
            bg: Colors.galBlack100
          },
          hollow: {
            color: Colors.galBlack100,
            border: Colors.galBlack47
          }
        }
    },
    commonCheckbox: {
        border: '#8e9193',
        color: '#fff',
        bg: '#2C2C2B',
        icon: {
            active: '#fff',
            notActive: 'transparent'
        }
    },
    tabs: {
        gradient: Colors.geo,
    },
    table: {
        border: Colors.galBlack100,
        headerBg: Colors.white,
        text: Colors.white,
        icon: {
            default: Colors.geoWhite47,
            active: Colors.geoWhite73,
        },
    },
    viewType: {
        item: {
            active: Colors.white,
            default: Colors.galBlack47,
            hover: Colors.galBlack27
        }
    },
    peoplePage: {
        title: {
            color: '#fff'
        }
    },
    subscribeInfo: {
        color: '#fefefe',
        hover: '#c5c6c7'
    },
    subscribeModal: {
        title: 'rgba(255, 255, 255, 1)',
        subTitle: 'rgba(255, 255, 255, 1)',
        channeTitle: "rgba(255, 255, 255, 1)"
    },
    teamMeta: {
        color: Colors.galBlack47,
        hover: Colors.galBlack73
    },
    landing_nav: {
        bg: '#464645',
        item: {
            color: '#A3A3A3',
            bg: '#464645',
            hover: '#464645',
            hoverColor: '#BFBFBF'
        }
    },
    folders: {
        emptyModal: {
            titleColor: '#fff',
            subtitleColor: '#fff'
        },
        editModal: {
            mainbg: '#2A3034',
            titleColor: '#2A3034',
            subtitleColor: '#909090',
            inputColor: '#353a3e',
            inputColor2: '#fff',
            buttonColorHollow: '#fff',
            buttonColorFill: '#fff',
            iconColor: '#fff'
        }
    },
    mainSearchBar: {
        bg: '#2C2C2B',
        placeholder: {
            color: Colors.galBlack47
        },
        input: {
            bg: '#2C2C2B',
            placeholder: {
                color: '#5D5D5D'
            }
        },
        text: {
            color: '#FEFEFE',
            color_desc: '#FEFEFE',
            hover: {
                color: '#353A3E'
            }
        },
        tabs: {
            color: "#909090",
            colorActive: "#fefefe"
        }
    },
    longreadTranslated: {
        bg: 'rgba(144, 144, 144, 0.8)',
        color: 'rgba(254, 254, 254, 1)'
    },
    relatedTitle:'rgba(254, 254, 254, 1)', 
    mainSearchBarFooter: {
        bg: '#2A3034',
        placeholder: {
            color: Colors.galBlack47
        },
    },
    educationSearchBar: {
        result: {
            color: '#fff'
        }
    },
    approvalBlockStyles: {
        color: Colors.galBlack47,
        bg: '#2C2C2B',
        radioCircle: '#2C2C2B',
        radioDot: '#FEFEFE',
        buttonColor: '#151514',
        buttonBg: '#FEFEFE'
    },
    mainDropdownStyles: {
        colorActive: Colors.geoWhite100,
        color: '#838382',
        bg: 'rgb(31, 31, 31)',
        hoverBG: ' rgb(44, 44, 43)'
    },
    mainBg: '#151514',
    loading: Colors.geoWhite47,
    tagView: {
        titleColor: Colors.geoWhite100,

        // Медиа
        goToMediaColor: Colors.geoWhite100,
        goToMediaHoverColor: Colors.geoWhite31,
    },
    longread: {
        border: 'none',
        fontSize: '',
        lineHeight: '',
    },
    progressbar: {
        color: Colors.geoWhite47,
        colorBold: Colors.geoWhite100,
        borderColor: Colors.geoWhite31
    },
    competition: {
        modal: {
            tagsTitle: {
                color: '#909090'
            }
        },
        search: {
            smallColor: Colors.geoWhite61
        },
        jury: {
            name: '#151514'
        },
        shortList: {
            description: {
                text: '#151514'
            }
        },
        result_table: {
            bg: "#cdcdcd",
            color: '#C5C6C7',
            border: '#575B5E'
        },
        nominationsBlock: {
            label: {
                color: '#fff'
            }
        },
        bg: '#000000',
        mainText: '#FEFEFE',
        frameMainText: '#fefefe',
        secondaryText: Colors.galBlack47,
        buttonBg: Colors.geoWhite100,
        buttonText: Colors.galBlack100,
        juryDesc: Colors.geoWhite47,
        langComponent: {
            active: {
                bg: '#BFBFBF',
                color: '#212120'
            },
            notActive: {
                bg: '#464645',
                color: '#909090'
            },

            mainSwitcher: {
                active: {
                    bg: '#BFBFBF',
                    color: '#212120'
                },
                notActive: {
                    bg: 'transparent',
                    color: '#BFBFBF'
                },
            }
        },
        label: {
            color: '#909090'
        },
        input: {
            bg: '#2C2C2B',
            bgActive: Colors.galBlack10,
            inputText: '#fff',
            placeholder: '#5D5D5D',
            mainText: '#151514',
            secondText: '#fefefe',
            button: {
                border: '#545453',
                bg:  '#F2F2F2'
            },
            checkbox: {
                border: '#838382',
                icon: '#fff',
                bg:  '#464645',
            },
            date: {
                bgNow: 'white',
                bgActive: 'transparent',
                colorNow: 'black',
                colorActive: 'white'
            }
        },
        table: {
            item: {
                bg: '#343434'
            },
            input: {
                bg: '#464645',
                color: '#fefefe',
                border: '#343434'
            }
        }
    },
    tagSearch: {
        titleColor: Colors.geoWhite47,
        subtitleColor: Colors.geoWhite47,
        subtitleColorHover: Colors.geoWhite100,
        inputColor: Colors.geoWhite100,
        background: Colors.geoWhite5,
        arrowColor: Colors.geoWhite47,
    },
    catalog: {
        titleColor: Colors.geoWhite100,
        subtitleColor: Colors.geoWhite100,
        descriptionColor: Colors.geoWhite100
    },
    tagItemView: {
        textColor: Colors.geoWhite100,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100,
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: Colors.geoWhite100,
    },
    exploreView: {
        titleColor: Colors.geoWhite100,
        mapGridToggle: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100,
        },
        illustrationColor: Colors.geoWhite73
    },
    allTagsBtn: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        colorBooksBtn: "#909090",
        colorHoverBooksBtn: "#545453"
    },
    multipleAuthors: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        bg: '#1c1c1d',
        bgHover: '',
        arrow: '#1c1c1d',
        border: '',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.geoWhite61,
    designerRoleUniversity: Colors.geoWhite100,
    textBoldMagic: Colors.geoWhite47,
    teamLink: Colors.geoWhite100,
    teamLinkHover: Colors.geoWhite61,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '',
        borderColor: 'transparent',
    },
    projectTools: {
        printButton: Colors.geoWhite100,
        outer: Colors.geoWhite10,
        rowTitle: Colors.gal,
        rowHover: Colors.geoWhite5,
        okBtn: "#A4B54D",
        okBtnText: Colors.geo,
    },
    checkbox: {
        border: "transparent",
        bg: Colors.geoWhite21,
        icon: Colors.geoWhite100,
    },
    paginationBtn: {
        color: '',
        border: '',
    },
    sortByColor: Colors.geoWhite47,
    sortByColorSort: Colors.geoWhite100,
    sortByBorder: '',
    sortByBg: '',
    sortBySpan: '#fefefe',
    nameViewHover: '#fefefe',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#262a2d',
        text: '#FFFFFF',
        scroll: '#909090',
        btns: {
            submit: {
                bg: Colors.geoWhite100,
                disabledBg: '#3F4548',
                color: '#151514',
                disabledColor: '#6C7073',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: '',
            },
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent',
            },
            dropdown: {
                backgroundColor: Colors.geoWhite5,
                backgroundColorHover: Colors.geoWhite10,
                scroll: Colors.galBlack47,
            },
            backgroundColor: Colors.geoWhite5,
            borderColor: Colors.geoWhite5,
            color: '#ffffff',
        },
    },
    feedbackForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: '',
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent',
            },
            dropdown: {
                backgroundColorHover: '',
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe',
        },
    },
    defaultHolder: {
        bg: '#353A3E',
        color: '#909090'
    },
    projectView: {
        titleColor: Colors.geoWhite100,
        titleColorMobile: Colors.geoWhite100,
        lGTitleColorMobile: Colors.geoWhite100,
        placeholderColor: '#B6B6B5',
        fontSize: '',
        lineHeight: '',
        tooltipColor: '#FFFFFF',
        tooltipColorBG: '#545453',
        categoryText: Colors.geoWhite31,
        categoryWeight: '',
        categoryColorHover: '',
        authorText: 'rgba(255,255,255,0.47)',
        authorCuratorText: Colors.geoWhite100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorTextSize: Colors.geoWhite73,
        authorColor: Colors.geoWhite47,
        authorColorHover: Colors.geoWhite100,
        authorColorHoverMobile: Colors.geoWhite61,
        authorArrowIconColor: Colors.geoWhite47,
        textAreaColor: Colors.geoWhite31,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#909090',
        marginTop: '',
        marginBottom: '',
        designerLink: Colors.geoWhite100,
        moreProjects: '#FFFFFF',
        offsetTop: '',
        madeBy: Colors.geoWhite47,
        border: 'transparent',
        competitionMsg: Colors.geoWhite100
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)',
    },
    footerView: {
        backgroundColor: '#22282c',
        textColor: Colors.geoWhite61,
        textHoverColor: Colors.generalPeaGreen,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
        linkArrow: Colors.geoWhite27,
    },
    arrowWithText: {
        hover: {
            text: {
                color: 'rgb(254,254,254)'
            },
            svg: {
                fill: 'rgb(254,254,254)',
                stroke: 'rgb(254,254,254)'
            }
        }
    },
    teamsPage: {
        button: {
            bg: '#FFFFFF'
        },
        dropdown: {
            text: {
                color: '#f4f4f4'
            }
        },
        input: {
            bg: "#30363A",
            color: '#f4f4f4'
        },
        text: {
            point: {
                color: '#f4f4f4'
            },
            label: {
                color: '#8E9193'
            },
            icon: {
                fill: '#fefefe'
            },
            color: '#ffffff'
        },
    },
    fixedFooter: {
        background: {
            color: "#1F1F1F"
        },
        logo: {
            color: "#FEFEFE",
        },
        menuItems: {
            color: '#8E9193',
            colorDropdown: '#8E9193',
            colorHover: "rgb(254, 254, 254)",
            selected: Colors.geoWhite100,
        },
        doc: {
            color: '#909090',
            colorHover: "#151514",
        },
        icons: {
            circle: '#1F1F1F',
            arrow: '#909090'
        },
        dropdown: {
            color: '#909090',
            fill: '#909090'
        }
    },
    legals: {
        textColor: Colors.geoWhite100,
        background: `${Colors.geo}FA`,
        closeBtn: Colors.geoWhite47,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
    },
    scroll: {
        bg: '#909090'
    },
    mobileLinks: {
        borderColor: "rgba(63, 69, 72, 1)"
    },
    cookies: {
        bg: "#212120",
        mainColor: "#fefefe",
        showMore: {
            color: '#fff'
        },
        icon: {
            fill: "#909090",
            hoverFill: "#fff"
        }
    },
    projectEdit: {
        book: {
            chaptersButtons: {
                hover: {
                    fill: '#fff'
                },
                color: '#fff'
            }
        },
        radio: {
            dot: {
                color: Colors.geoWhite100
            }
        },
        inputs: {
            bg: Colors.galBlack5,
            color: Colors.galBlack100,
            placeholder: Colors.galBlack31
        }, 
        protectBlock: {
            input: {
                bg: '#3F4548',
                altBg: Colors.galBlack5,
                color: Colors.galBlack100,
                placeholder: {
                    color: Colors.galBlack31
                }
            },
            infoMsg: {
                color: '#909090'
            },

            paid_block: {
                button: {
                    bg: '#151514',
                    color: '#fff'
                }
            }
        },
        presentation: {
            input: {
                bg: '#2C2C2B',
                dropdownHover: '#464645'
            }
        },
        imgContainerBg: '#2C2C2B',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.zelWhite47,
        locationText: Colors.geoWhite61,
        locationBoldText: Colors.geoWhite47,
        label: '#ffffff',
        frame: {
            mainTitle: {
                color: '#C5C6C7'
            },
            description: {
                color: '#C5C6C7'
            },
            link: {
                color: '#6C7073'
            }
        },
        btns: {
            age: {
                bg: '#2C2C2B',
                border: Colors.galBlack47,
                icon: {
                    color: '#fff'
                }
            },
            lang: {
                active: '#f4f4f4',
                disabled: '#3F4548',
                activeColor: '#151514',
                disabledColor: '#909090',
                biling: {
                    color: '#909090',
                    bg: '#3F4548',
                    border: 'transparent'
                }
            },
            create: {
                bg: '',
                color: '',
                weight: '',
                border: '',
            },
            tag: {
                bgActive: '#fff',
                border: '#8E9193',
                borderActive: '#fff',
                color: '#FFFFFF',
                colorActive: '#151514'
            },
            navbar: {
                disabled: {
                    bg: '#212120',
                    color: '#8E9193'
                },
                exit: {
                    border: {
                        notActive: {
                            color: '#575B5E'
                        }
                    }
                }
            }
        },
        mobile: {
            inputs: {
                color: '#fff',
                bg: '#353A3E',
                placeholder: '#909090'
            },
            items: {
                color: '#fefefe',
                bg: 'transparent'
            },
            buttons: {
                color: '#FFFFFF',
                bg: 'transparent',
                border: '#FFFFFF',
                fill: '#FFFFFF',
                hover: {
                    color: '#CDCDCD',
                    border: '#CDCDCD',
                },
                disabled: {
                    bg: 'transparent',
                    color: '#545453',
                    border: '#545453',
                }
            }
        },
        header: {
            color: 'rgba(255, 255, 255, 0.47);'
        },
        search: {
            inputs: {
                fill: "#909090",
                hoverFill: "#fefefe"
            }
        },
        publishModal: {
            bg: "#3F4548",
            title: {
                color: "#fefefe"
            },
            subtitle: {
                color: "#fefefe"
            },
            buttons: {
                hollow: {
                    color: "#151514",
                    bg: "#fefefe",
                    border: '#b6b6b5'
                },
                filled: {
                    color: "#fefefe",
                    bg: "#151514",
                    border: "transparent"
                }
            }
        }
    },
    icon: {
        default: 'rgba(255,255,255,0.47)',
        hover: Colors.geoWhite100,
        active: Colors.geoWhite100,
        hoverSpecial: Colors.geoWhite100,
        hoverSpecialActive: "#909090",
        activeSpecial: Colors.geoWhite100,
        activeFillIconColor: Colors.geoWhite100,
        rejectedColor: '#F2F2F2',
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.geoWhite100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        projectEditTagsPlusBtn: '#fefefe',
        tagsSearchPlaceholderText: Colors.geoWhite61,
        emptySearchColor: Colors.geoWhite61,
        competitionSortColor: '#151514',

        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.galBlack27,
        borderColorActive: Colors.geoWhite100,

        selectedCategory: Colors.zelWhite5,

        cloud: {
            background: Colors.galBlack5,
            selectedTag: '#EA3323',
            selectedTagHSE: '#146DEE',
            selectedTagHSEHover: '#0A56C4',
        },

        tagEditModal: {
            buttons: {
                edit: {
                    color: '#fff',
                    borderColor: '#fff'
                }
            },
            subTitle: {
                color: '#fff'
            },
            input: {
                bg: '#3f4548',
                color: '#fff'
            },
            text: {
                color: '#fff'
            }
        },

        removable: {
            textColorHover: Colors.galBlack47,
            borderColorHover: Colors.galBlack47,

            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100,
                },
                textColor: Colors.galBlack47,
                borderColor: '#FFFFFF',
            },
        },

        selected: {
            backgroundColor: '#FFFFFF',
            borderColor: '#2a3034',
            textColor: '#000000',
            hover: {
                borderColor: '#FFFFFF',
            },
        },
        disabled: {
            backgroundColor: '#272b2d',
            borderColor: '#3f4548',
            color: Colors.geoWhite21,

            hover: {
                borderColor: '#3f4548',
            },
        },
        educational: {
            backgroundColor: Colors.geoWhite100,
            backgroundColorHover: Colors.geoWhite5,
            color: Colors.galBlack100,
            unitColor: Colors.geoWhite100,
            projectEdit: {
                // backgroundColor: Colors.generalPeaGreen,
                backgroundColor: Colors.geoWhite100,
                backgroundHover: Colors.geoWhite100,
                color: '#2A3034',
            }
        },
        modal: {
            search: {
                color: Colors.geoWhite47,
                border: Colors.geoWhite21,
                borderEmpty: 'transparent',
                bg: '#212120'
            },
            header: {
                color: Colors.geoWhite100,
                colorLvlOne: Colors.geoWhite100
            },
            text: {
                color: Colors.geoWhite47,
            },
            active: {
                activeTag: Colors.geoWhite100,
                border: Colors.geoWhite61
            },
            searchResult: {
                bg: '#212120'
            },
            notActive: {
                tag: Colors.geoWhite73,
                border: Colors.geoWhite31
            },
            simpleTag: {
                color: Colors.geoWhite100,
                bottomLine: '#3F4548'
            }
        }
    },
    hoverModal: {
        bg: {
            color: '#212120'
        }
    },
    skeleton: {
        skeletonBgColor: 'rgba(63, 69, 72, 0.5)',
        background: `linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.10),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05),
            rgba(255, 255, 255, 0.05)
        )`,
    },
    selectContextModal: {
        background: Colors.geo,
        loaderText: '#FEFEFE',
        opacityTop: 'linear-gradient(to top, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        opacityBottom:
          'linear-gradient(to bottom, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        variantTextColor: Colors.geoWhite100,
    },
    shopIcon: Colors.geoWhite100,
    shareIcon: Colors.geoWhite100,
    shareModal: {
        bg: '#212120',
        inputs: {
            bg: '#3F4548'
        }
    },
    ageModal: {
        bg: '#353A3E',
        input:{
            color: '#fff'
        },
    },
    sendProjectsModal: {
        title: Colors.geoWhite100,
        label: Colors.galBlack47,
        countText: '#909090',
        buttons: {
            send: {
                bg: Colors.geoWhite100,
                color: Colors.galBlack100,
                importantColor: Colors.geoWhite100,
                colorGreen: Colors.galBlack100,
                hoverBg: Colors.geoWhite100,
                greenBg: 'rgb(164, 181, 77)',
                greenBgHover: 'rgb(164, 181, 77)',
                disable: "#C5C6C7",
                disableClr: '#8E9193'
            }
        },
        input: {
            color: '#fff',
            bg: 'rgb(70, 70, 69)'
        }
    },
    competitionLegalsModal: {
        input: {
            bg: '#30363A',
            placeholder: '#909090',
            color: Colors.geoWhite100,
            border: '#909090',
            icon: Colors.geoWhite100,
            defaultBorder: 'transparent'
        }
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    navigationBar: {
        borderBottomColor: Colors.geoWhite21,
        textActiveColor: '#ffffff',
        boxShadow: 'inset 0px 2px 3px rgba(22, 22, 23, 0.21)',
        closeButtonColor: '#FFFFFF',
        backgroundColor: '#151514',
        mainNavbarColor: 'rgb(42,48,52)',
        backgroundScrollingColor: '#000000',
        backgroundDirtyColor: '#FF0000',
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: '#8E9193',
            hoverColor: '#C5C6C7',
            activeColor: '#C5C6C7',
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(197, 198, 199, 0.3)'
        },
        linksHse: {
            color: Colors.geoWhite47,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(197, 198, 199, 0.3)'
        },
        logoName: '#FF0000',
        logoPrefixName: Colors.geoWhite100,
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: Colors.geoWhite100,
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477',

            dropDownColor: Colors.galBlack47,
            dropDownBackground: '#1f1f1f',
            dropDownDisabledColor: '#B6B6B5',
            dropDownHoverBackground: '#212120',
            dropDownHoverColor: Colors.galBlack73,
            dropdownContentBg: '#1f1f1f',
            dropDownShadowColor: '#1f1f1f',
        },
        search: {
            color: '#FEFEFE',
            line: '#FFFFFF',
            svg: '#8E9193',
            svgHover: Colors.geoWhite100,
            colorFlex: 'rgb(254, 254, 254, 0.71)',
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: '#fff',
        },
        linksWidgetLine: '#ffffff',
        linksWidgetLineGradient: Colors.geoWhite100, //old ' radial-gradient(100% 1562500% at 0% 100.02%,rgba(255, 255, 255, 0) 0%,#fefefe 49.87%,rgba(254, 254, 254, 0) 100%)',
        btns: {
            purchase: {
                background: {
                    color: Colors.geoWhite100
                },
                text: {
                    color: Colors.galBlack100
                }
            },
            filled: {
                importantStyles: {
                    main: Colors.generalPeaGreen,
                    disabled: Colors.galBlack10,
                    hover: '#FFFFFFF',
                    active: '#FFFFFFF',
                    text: Colors.galBlack100
                },
                background: {
                    main: '#FEFEFE',
                    disabled: Colors.galBlack10,
                    hover: '#FFFFFFF',
                    active: '#FFFFFFF',
                },
                text: {
                    main: '#151514',
                    disabled: Colors.galBlack31,
                },
            },
            hollow: {
                background: {
                    disabled: Colors.geoWhite73,
                },
                text: {
                    main: '#ffffff',
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.geoWhite47,
                },
                border: {
                    main: Colors.geoWhite21,
                    hover: Colors.geoWhite31,
                    active: Colors.geoWhite47,
                    disabled: Colors.geoWhite10,
                },
            },
            send: {
                color: '',
                textColor: '',
                border: '',
            },
            create: {
                bg: '#FFFFFF',
                color: Colors.galBlack100,
                weight: '',
                border: '',
            },
            changeLang: {
                background: '#212120',
                color: Colors.geoWhite47,
                colorMobile: Colors.geoWhite100,
                colorHover: Colors.geoWhite47,
                active: Colors.geoWhite100,
            },
            showMore: {
                hover: {
                    color: Colors.zelWhite73
                }
            }
        },
        navBarCreate: {
            boldTextColor: Colors.geoWhite61,
            textColor: '#6C7073',
            logoFillColor: {
                first: '#FEFEFE',
                second: '#A4B54D',
            },
        },
        dropdownStyled: {
            bg: '#30363a',
            border: '1px solid rgba(254, 254, 254, 0)',
            borderFocused: 'rgba(254, 254, 254, 0.13)',
            textColor: '#fefefe',
            opacity: '0.31',
            fill: '#fefefe',
        },
        profile: {
            textColor: Colors.geoWhite100,
            textSmallColor: Colors.geoWhite61,
            bg: Colors.geo,
        },
        mobileMenu: {
            item: {
                color: '#909090',
                colorActive: '#FFFFFF',
                bg: 'rgba(33, 33, 32, 1)'
            },
            container: {
                bg: 'rgba(33, 33, 32, 1)',
                boxShadow: 'inset 0 -1px 0 #3f4548'
            },
            search: {
                bg: '#575B5E'
            },
            tab: {
                color: 'rgba(131, 131, 130, 1)',
                colorActive: '#ffffff'
            }
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.geoWhite10,
            backgroundHover: Colors.geoWhite5,
        },
        scroll: {
            body: Colors.galBlack47,
            background: Colors.geoWhite5,
        },
        input: {
            color: Colors.geoWhite100
        },
        item: {
            color: Colors.geoWhite100,
        }
    },
    likesController: {
        textColor: Colors.geoWhite47,
        fill: '',
        hearthColor: Colors.geoWhite47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.geoWhite47,
    },
    viewCount: {
        text: Colors.geoWhite47
    },
    likesPopUp: {
        bg: '#1c1c1b',
        color: '#abaeaf',
        hoverColor: Colors.geoWhite100,
        bgHover: '',
        borderBox: '1px solid transparent',
    },
    likesPopUpNew: {
        bg: Colors.geoWhite10,
        color: Colors.geoWhite100,
        bgHover: Colors.geoWhite5,
        scrollBody: Colors.galBlack47,
    },
    researchPage: {
        colorMainTitle: Colors.geoWhite61,
    },
    btns: {
        submit: {
            bg: '#fede31',
            color: Colors.galBlack100,
            border: '',
            hoverBg: '#efd649',
            weight: '',
        },
        cancel: {
            bg: '',
            color: '',
            border: '',
            hoverBorder: '',
        },
        hollow: {
            border: Colors.geoWhite21,
            borderActive: Colors.geoWhite100,
            icon: Colors.geoWhite100,
        }
    },
    inputs: {
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: 'transparent',
        },
        dropdown: {
            backgroundColorHover: '',
        },
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderFocusedColor: Colors.geoWhite31,
        color: 'rgba(144, 144, 144, 1)',
        disabledColor: Colors.geoWhite100,
        pagination: {
            backgroundColor: Colors.zelWhite21,
            color: Colors.geoWhite100,
            mainPagination: {
                pageBg: {
                    bg: '#464645'
                }
            }
        },
        box: {
            backgroundColor: 'rgba(44, 44, 43, 1)'
        },
        label: {
            color: 'rgba(144, 144, 144, 1)'
        },
        text: {
            color: Colors.geoWhite47
        }
    },
    dropdown: {
        scrollColor: '#5D5D5D',
        textColor: Colors.galBlack100,
        bgColor: '#32373b',
        bgColorHover: '#212120',
        borderColor: '#30363a',
        borderFocusColor: 'transparent',
        arrow: '#fefefe',
        shadow: 'rgba(0, 0, 0, 0.3)',
        shadowEnd: 'rgba(0, 0, 0, 1)',

        shadowHse: 'rgba(0,0,0,0)',
        shadowHseEnd: '#343434',
        webkitShadowStart: 'rgba(52,52,52,1)',
        webkitShadowEnd: 'rgba(52,52,52,0.3)'
    },
    spinner: {
        loaderColor: '#ffffff',
        loaderBg: Colors.geo,
    },
    designerPage: {
        emptyProjectsLoader: {
            color: Colors.geoWhite100,
            bg: '#30363a',
        },
        noProjectBlock: {
            infoBlock: {
                bg: '#212120',
                color: '#fefefe'
            },
            avatar: {
                color: '#70706f',
                bg: '#909090',
                size: {
                    l: 48
                }
            }
        },
        likePowerIcon: {
            color: Colors.geoWhite47,
            bg: 'rgba(254,254,254,0.73)',
            opacity: '0.73',
            msgColor: Colors.galBlack100,
            shrinkColor: Colors.galBlack100,
            hover: Colors.geoWhite73
        },
        slideShadow: 'linear-gradient(270deg, #000000 9.68%, rgba(42, 48, 52, 0.00) 100%)',
        slideItemBg: Colors.geoWhite10,
        textColor: Colors.geoWhite100,
        textColor2: Colors.geoWhite47,
        textColor3: Colors.geoWhite100,
        fill: '#FEFEFE',
        sliderDropdownColor: '#909090',
        moreDropdown: '',
        slideLine: '#f4f4f4',
        slideNavActiveTabUnderline: '#FFFFFF',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.geoWhite73,
        blueSelectBG: '#609AF0', 
        blueSelectColor: '#fefefe' , 
        viewCardText: '#FEFEFE',
        viewCardStroke: '#8e9193',
    },
    wideCover: {
        info: {
            author: {
                color: Colors.galBlack47,
            },
            title: {
                color: '#151514'
            }
        }
    },
    teamsEdit: {
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        }
    },
    gridItem: {
        color: '#fff'
    },
    designerEdit: {
        btns: {
            edit: {
                bg: '#fff',
                color: Colors.galBlack100,
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#f4f4f4',
                border: '',
                hoverBorder: '',
            },
            roundAdd: {
                svgColor: Colors.geoWhite100,
                textColor: Colors.geoWhite47,
            },
            subscribe: {
                dropdown: {
                    color: '#8E9193',
                    background: '#1f1f1f',
                    hoverBg: '#2c2c2b',
                    hoverColor: '#bfbfbf'
                }
            }
        },
        localSwitch: {
            borderColor: Colors.geoWhite100,
            textColor: Colors.geoWhite100,
            textColorInactive: Colors.geoWhite47,
            textColorHover: Colors.geoWhite73,
        },
        inputs: {
            labelColor: 'rgba(142, 145, 147, 1)',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)',
            placeholder: '#5D5D5D'
        },
        smallText: {
            color73: Colors.geoWhite73,
            color100: "rgba(144, 144, 144, 1)",
            color47: Colors.geoWhite47,
            colorB6: '#B6B6B5',
            colorE7: 'rgba(144, 144, 144, 1)'
        },
        editTitle: {
            color: 'rgba(144, 144, 144, 1)',
            secondColor: Colors.geoWhite100
        },
        mainTitle: {
            color: '#f4f4f4',
        },
        pageLink: {
            color: Colors.geoWhite100,
            hoverColor: Colors.geoWhite100,
        },
        aboutProfile: {
            bg: 'rgba(44, 44, 43, 1)',
            bgWhite: Colors.geoWhite73,
            color: Colors.geoWhite100,
        },
        mergeAccount: {
            bg: 'rgba(33, 33, 32, 1)'
        },
        account: {
            color: 'rgba(144, 144, 144, 1)',
            color47: Colors.geoWhite47,
            goButtonColor: 'rgb(244,244,244)',
            color31: 'rgba(144, 144, 144, 1)',
            fill: 'rgb(205, 205, 205)'
        },
        icons: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        disable: {
            color: Colors.geoWhite27,
            colorGeo: Colors.galBlack47
        },
        placeholder: {
            color: 'rgb(108, 112, 115)',
        }
    },
    map: {
        closeBtn: '#ffffff',
        bg: '#2a3034',
        exploreBtn: {
            mobile: {
                color: '#838382',
                fill: '#838382'
            },
            desktop: {
                color: '#8E9193',
                fill: '#8E9193'
            }


        },
        teams: {
            text: Colors.galBlack61,
            secondaryText: Colors.galBlack47,
            scroll: '#CDCDCD'
        }
    },
    footer: {
        border: '',
    },
    errorModal: {
        textColor: Colors.geoWhite100,
        textColorSecond: Colors.geoWhite100,
        secondaryTextColor: Colors.geoWhite47,
        backgroundColor: Colors.geo,
    },
    modal: {
        closeColor: Colors.geoWhite100,
        backgroundColor: 'rgba(38, 44, 48)',
        solidBackgroundColor: "#000",
        overflowColor: 'rgba(21, 21, 20, 0.6)',
        buttons: {
            saveButtonBG: '#fefefe',
            saveButtonColor: '#151514'
        },
        tagModal: {
            buttons: {
                saveButtonBG: '#fefefe',
                saveButtonColor: '#151514'
            }
        }
    },
    not_saved_modal: {
        title: "#f4f4f4",
        description: "rgb(197, 198, 199)",
        cancel: Colors.galBlack100,
        proceed: Colors.geoWhite100,
        channelTitle: Colors.galBlack47
    },
    gallllery: {
        cardSubtext: '#919191',
        mainText: Colors.galBlack100,
        mainTextInactive: '#969696',
        hoverTitleText: '#FFD700',
        hoverText: '#919191',
        hoverAuthor: Colors.galBlack100,
        backgroundColor: 'white',
        borderBottomColor: 'transparent',
        boxShadow: 'none',
        backdrop: 'blur(1px)',
    },
    artz: {
        searchLine: {
            placeholderColor: '#1F1F1F',
            textColor: Colors.galBlack100,
        },
        buttons: {
            viewAllColor: Colors.gal,
        },
    },
    menuOverlay: {
        buttonBackground: '#353a3e',
        buttonContent: '#C5C6C7',
        buttonOpacity: 0.39,
        backgroundColor: '#2a3034',
        textColor: '#ffffff',
        textColorAlternative: '#ABAEAF',
        borderTitle: '#fefefe',
        flexBox: 'rgb(254, 254, 254, 0.71)',
    },
    approvals: {

    },
    isDarkText: false,
    link: {
        default: Colors.geoWhite47,
        hover: Colors.geoWhite100,
    },
    linkSpecial: {
        hover: Colors.geoWhite100,
    },
    scrollUp: {
        link: Colors.zelWhite100,
        background: 'transparent',
        backgroundHover: hexToRGB(Colors.zelWhite100, 0.01),
    },
    text: {
        label: Colors.geoWhite47,
    },
    mobileMenu: {
        background: '#2A3034',
    },
    notifications: {
        background: '#2C2C2B',
        backgroundUnread: Colors.geoWhite5,
        backgroundHover: "#212120",
        borderColor: "#464645",
        projectBackground: Colors.geoWhite21,
        projectBackgroundUnread: Colors.geoWhite10,
        likes: Colors.galBlack27,
        textColor: '#FFFFFF',
        link: '#FFFFFF',

        name: {
            color: "#151514",
        }
    },
    errorPage: {
        notFound: {
            number: Colors.geoWhite31,
            title: Colors.geoWhite47
        },
        title: Colors.geoWhite100,
        subtitle: Colors.geoWhite100,
        text: Colors.geoWhite47,
        buttons: {
            border: Colors.geoWhite31,
            hollowText: Colors.geoWhite100,
            bg: Colors.geoWhite100,
            filledText: Colors.geo,
            disabledBg: Colors.galBlack21,
            disabledColor: Colors.galBlack31,
        }
    },
    imagePlaceholder: {
        bg: "#30363a",
        icon: "#65696c"
    },
    draftCreate: {
        primary: "#30363a",
        secondary: "#c5c6c7",
        borderHover: "#8e9193",
        textHover: "#fefefe",
        title: Colors.geoWhite100,
        draftCards: {
            psn_card: {
                color: Colors.galBlack100
            }
        }
    },
    tagAdminPage: {
        dropdownSelected: "#FEFEFE",
        dropdown: "#FEFEFE",
        inputs: {
            bg: 'rgba(63, 69, 72, 1)',
            border: 'transparent',
            placeholder: {
                color: 'rgba(144, 144, 144, 1)'
            }
        },
        checkbox: {
            bg: '#fefefe'
        },
        select: {
            color: '#fff'
        },
        scrollBar: {
            bg: '#fff',
            trackBg: 'rgba(53, 58, 62, 1)'
        },
        icons: {
            fill: '#909090'
        },
        tagExpert: {
            mainText: Colors.geoWhite27,
            secondaryText: Colors.galBlack47,
            secondaryTextHover: Colors.geoWhite100,
            background: Colors.geoWhite10
        },
        switcher: {
            bg: 'rgba(63,69,72,1)',
            item: {
                color: '#838382',
                hoverColor: Colors.geoWhite100
            }
        }
    },
    sendGift: {
        white: "",
        background: "#F2F2F2",
        mainBg: "",
        bg10: "",
        bg21: "",
        black: "",
        buttonBlack: "",
        share: "",
        text: "",
        text47: "",
        text61: "",
        text73: "",
        input: {
            hover: "",
            focus: "",
        },
        addDet: {
        }
    },
    payment: {
        bigText: Colors.zelWhite100,
        summary: Colors.zelWhite10,
        country: {
            viewLabel: Colors.galBlack61,
            draftMessage: Colors.galBlack73,
            successMessage: Colors.galBlack47,
        },
        chooseMethod: {
            bg: 'inherit',
            methods: {
                tugriks: {
                    bg: Colors.zelWhite10,
                    bgInactive: "#B4BBBD",
                    giftBg: Colors.zelWhite5,
                    hoverBg: "#2E2E2D",
                    hoverGiftBg: "#252524",
                    title: Colors.zelWhite100,
                    desc: Colors.zelWhite73,
                    paymentVal: Colors.zelWhite73,
                    additional: Colors.zelWhite73
                }
            }
        }
    },
    topup: {
        wrapper: Colors.gal,
        wrapperMob: Colors.galBlack10,
        title: Colors.galBlack100,
        bundle: {
            wrapper: Colors.galBlack5,
            title: Colors.galBlack73,
            subtitle: Colors.galBlack47,
            hint: Colors.galBlack31,
            amount: Colors.galBlack100
        },
        button: Colors.galBlack100,
        buttonText: Colors.gal
    },
    madeByMedia: {
        background: '#464645',
        color: '#FEFEFE'
    }
};